<template>
<div class="flex w-full vx-row no-gutter justify-center">
  <div class="vx-col sm:w-full md:w-full lg:w-3/5">
    <!-- <start-study v-show="!isStart" v-bind:studyInfo="studyInfo" @onStart="onStart"/> -->
    <vx-card class="study-card">
      <vs-list>
        <vs-list-header title="원어민 발음에 집중하여 잘 들어 보세요." icon-pack="feather" icon="icon-info"></vs-list-header>
        <vs-list-item class="msg-grp-container">
          <vs-chip color="warning mr-0">{{ contentIndex + 1 }} / {{contentsLen}}</vs-chip>
        </vs-list-item>
      </vs-list>
      
      <div class="flex justify-center">
        <img :src="content.image" style="max-height:240px">
      </div>
      
      <!-- <swiper ref="imageSwiper">
        <swiper-slide :key="index" v-for="(content, index) in contentList" class="image-box">
          <img :src="content.image">
        </swiper-slide>
      </swiper> -->

      <div class="text-center mt-6">
        <audio ref="audioPlayer" 
          controls 
          hidden
          v-on:ended="audioFinish" 
          controlsList="nodownload">Your browser does not support the <code>audio</code> element.
        </audio>
      </div>  
    </vx-card>
    <top-button-bar @onReload="onReload" @onNext="onNext" @onFinish="onFinish" ></top-button-bar>
  </div>  
</div>
</template>

<script>
import StudyMenuMixin from './StudyMenuMixin'
import TopButtonBar      from './TopButtonBar.vue'
// import 'swiper/dist/css/swiper.min.css'
// import { swiper, swiperSlide } from 'vue-awesome-swiper'
// import StartStudy          from './StartStudy.vue'

export default {
  mixins: [StudyMenuMixin],
  components: {
    TopButtonBar
    //swiper,
    // StartStudy,
    //swiperSlide
    
  },
  data () {
    return {
      contentList: [],
      contentsLen: 0,
      contentIndex: 0
    }
  },
  watch: {
    
  },
  computed: {
    // swiper () {
    //   return this.$refs.imageSwiper.swiper
    // },
    audioPlayer () {
      return this.$refs.audioPlayer
    },
    content () {
      return this.contentList[this.contentIndex]
    }
  },
  methods: {
    onReload () {
      this.audioPlayer.pause()
      this.contentIndex = 0
      this.startAlert()
    },
    onStart () {
      this.audioPlayer.src = this.content.audio
      this.audioPlayer.play()
      //this.swiper.slideTo(this.contentIndex, 0, false)
    },
    audioFinish () {

      if (this.contentIndex < (this.contentsLen - 1)) {
        this.contentIndex++
        this.audioPlayer.src = this.content.audio
        this.audioPlayer.play()
        //this.swiper.slideTo(this.contentIndex, 1000, false)
      } else {
        this.onComplete()
      }
    },
    acceptAlert () {
      this.onStart()
    },
    startAlert () {
      this.startStudyDlg('원어민 발음에 집중하여 잘 들어 보세요.')
    }
  },
  created () {

    const contentJson = JSON.parse(this.sourceContent.contentBody)
    for (let i = 0; i < contentJson.sentence.length; i++) {
      const content = {
        sentence: contentJson.sentence[i],
        audio: this.$buildAudioPath(this.sourceContent.contentCode, i + 1),
        image: this.$buildImagePath(this.sourceContent.contentCode, i + 1)
      } 
      this.contentList.push(content)
    }
    
    this.contentsLen = this.contentList.length
    this.startAlert()
  }
}

</script>

<style scoped>
.image-card {
  width: 360px
}
.image-box {
    height: 360px;
    display: flex;
    align-items: center;
    justify-content: center;
}
.image-box img {
    max-width: 100%;
    max-height: 100%;
}
</style>
